import type { ReduxActionOutcome, ReduxNonApiAction } from 'app/store/storeTypes';
import type { TabId, InspectorTabId, ProjectTabId } from './constants';
import {
    SELECT_WORKBENCH_DATASET_TAB,
    TOGGLE_MAXIMIZED_PREVIEW,
    SELECT_WORKBENCH_PROJECT_TAB,
    SELECT_WORKBENCH_GROUP_TAB,
    SELECT_WORKBENCH_INSPECTOR_TAB,
    SELECT_PROJECT_INSPECTOR_TAB,
    TOGGLE_AUTORUN_PREVIEW
} from './types';

export const doSelectWorkbenchDatasetTab = (tab: string, entityId: string) =>
    ({
        type: SELECT_WORKBENCH_DATASET_TAB,
        payload: { tab, entityId }
    }) as const satisfies ReduxNonApiAction;

export const doSelectWorkbenchProjectTab = (tab: ProjectTabId) =>
    ({
        type: SELECT_WORKBENCH_PROJECT_TAB,
        payload: { tab }
    }) as const satisfies ReduxNonApiAction;

export const doSelectWorkbenchGroupTab = (tab: TabId) =>
    ({
        type: SELECT_WORKBENCH_GROUP_TAB,
        payload: { tab }
    }) as const satisfies ReduxNonApiAction;

export const doSelectWorkbenchInspectorTab = (tab: InspectorTabId) =>
    ({
        type: SELECT_WORKBENCH_INSPECTOR_TAB,
        payload: { tab }
    }) as const satisfies ReduxNonApiAction;

export const doSelectProjectInspectorTab = (tab: InspectorTabId) =>
    ({
        type: SELECT_PROJECT_INSPECTOR_TAB,
        payload: { tab }
    }) as const satisfies ReduxNonApiAction;

export const doToggleMaximizedPreview = () =>
    ({
        type: TOGGLE_MAXIMIZED_PREVIEW
    }) as const satisfies ReduxNonApiAction;

export const doToggleAutoRunPreview = () =>
    ({
        type: TOGGLE_AUTORUN_PREVIEW
    }) as const satisfies ReduxNonApiAction;

export type PreferencesActionOutcome =
    | ReduxActionOutcome<ReturnType<typeof doSelectWorkbenchDatasetTab>>
    | ReduxActionOutcome<ReturnType<typeof doSelectWorkbenchProjectTab>>
    | ReduxActionOutcome<ReturnType<typeof doSelectWorkbenchGroupTab>>
    | ReduxActionOutcome<ReturnType<typeof doSelectWorkbenchInspectorTab>>
    | ReduxActionOutcome<ReturnType<typeof doSelectProjectInspectorTab>>
    | ReduxActionOutcome<ReturnType<typeof doToggleMaximizedPreview>>
    | ReduxActionOutcome<ReturnType<typeof doToggleAutoRunPreview>>;
